import React, { useEffect, useState } from "react";
import styles from "./scss/leftsidebar.module.scss";
import ContactLists from "./contactlists";
import { URInput } from "../../../shared/widgets/input";
import { Menu, Dropdown, Modal } from 'antd';
import CreateTaskCenter from "../rightsidebar/taskcreatecenter";
import { URButton } from "../../../shared/widgets/button";
import CreateDropDown from "../../chat/leftsidebar/createdropdown";
import { chats, contacts, initialStateModel } from "../../../models/model";
import { useSelector } from "react-redux";
import { filterFavouriteContacts, SearchFilter,groupingContacts, enablePermissionSafari, enablePermission } from "../../../base/utils";
import NotificationBottom from "../../chat/chatWidgets/notificationBottom";
import { chatSideWindow } from "../../../base/eventService/eventApiService";
import createContact from "../../../styles/images/createContact.svg";
type MainContactPageState = {
  searchContacts: Array<any>;
  filterKey:string;
  isFilter:boolean;
  isSearch:boolean;
  searchText:string;
  listContacts: Array<any>;
  isLoading:boolean;
}
const LeftsideBars = React.memo(() => {
  const contactList: contacts = useSelector((state: initialStateModel) => state.contactReducer);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [defaultContacts, setdefaultContacts] = useState<MainContactPageState>
  ({searchContacts:[],filterKey:"",isFilter:false,isSearch:false,searchText:"",listContacts:[],isLoading:false});
  const chat_reducer: chats = useSelector((state: initialStateModel) => state.chatReducer);
  // const showModal = () => {
  //   setIsModalVisible(true);
  // };
  chat_reducer.isWindowSlide && chatSideWindow(false, "", {});
  const [getsearchExtension,setsearchExtension] = useState(''); 

  useEffect(() =>{
    searchContact('');
    },[contactList?.allContacs?.length]);

  // const handleOk = () => {
  //   setIsModalVisible(false);
  // };
  const handleCancel = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    if(navigator.userAgent.indexOf("Safari") !== -1 || navigator.userAgent.indexOf("Firefox") !== -1)
    {
      enablePermissionSafari('calls');
    }
    else{
      enablePermission('calls');
    }
 }, []);

  
  const searchContact =(e:any)=>{
    let searchText:string = e?.target?.value?.toLowerCase()?.trim() || '';
    setsearchExtension(searchText);
    let searchResponse: Array<any>;
    if(defaultContacts.filterKey==="All"){
      searchResponse = SearchFilter(contactList.allContacs,searchText);
    }
    else if(defaultContacts.filterKey==="Work"){
      searchResponse = SearchFilter( contactList.workContacts,searchText);
    }else if(defaultContacts.filterKey==="Team"){
      searchResponse = SearchFilter(contactList.teamContacs,searchText);
    }
    else if(defaultContacts.filterKey==="Favourites"){
      let response =   filterFavouriteContacts(contactList.allContacs);
      searchResponse = SearchFilter(response,searchText);
    }
    else
    {
      searchResponse = SearchFilter(contactList.allContacs,searchText);
    }
    setdefaultContacts({...defaultContacts,
      searchContacts:groupingContacts(searchResponse),
      listContacts:searchResponse,
      isSearch: contactList.allContacs?.length >0? true:false,
      isLoading: contactList.allContacs?.length >0? true:false,
      isFilter:false,searchText:e?.target?.value || '' });
  };

  const selectfilter = (val:any)=>{
    let response : Array<any> = [];
    if (defaultContacts.searchText !== '') {
      
      if(val.key==="All"){
        response  = SearchFilter(contactList.allContacs,defaultContacts.searchText);
      }
      else if(val.key==="Work"){
        response = SearchFilter( contactList.workContacts,defaultContacts.searchText);
      }else if(val.key==="Team"){
        response = SearchFilter(contactList.teamContacs,defaultContacts.searchText);
      }
      else if(val.key==="Favourites"){
        let favResponse = filterFavouriteContacts(contactList.allContacs);
        response = SearchFilter(favResponse,defaultContacts.searchText);
      }
    }
    else {
      if(val.key==="Work"){
        response = Array.isArray(contactList.workContacts) ? contactList.workContacts : [];
      }
      else if (val.key === "Team"){
        response = Array.isArray(contactList.teamContacs) ? contactList.teamContacs : [];
      }
      else if (val.key === "Favourites"){
        response = filterFavouriteContacts(contactList.allContacs);
      }
      else if (val.key === "All"){
        response = Array.isArray(contactList.allContacs) ? contactList.allContacs : [];
      }

    }
    
    
    setdefaultContacts({...defaultContacts,
      searchContacts:groupingContacts(response),
      listContacts:response,
      filterKey:val.key,
      isFilter:true,
      isSearch:false});
  };
  const menus = (
    <Menu className="rightdropactions contactsright" onClick={selectfilter}>
      <Menu.Item className="active" key={'All'}>All</Menu.Item>
      <Menu.Item key={'Work'}>Work</Menu.Item>
      <Menu.Item key={'Team'}>Team</Menu.Item>
      <Menu.Item key={'Favourites'}>Favourites</Menu.Item>
    </Menu>
  );
 
 
  return (
    <>
      <div className={styles.leftsidebar}>
        <div className={styles.top}>
          <CreateDropDown></CreateDropDown>
        </div>
        {/* {(!chat_reducer.notifyPermission || !chat_reducer.audioPermission || !chat_reducer.videoPermission) && <div className={styles.notificationtop}><NotificationBottom /></div>} */}
        {(contactList?.jenkinMessage )&& <div className={styles.notificationtop}><NotificationBottom  /></div>}
        <div className={styles.middlelayertop}>
          <URInput placeHolder="Search" className="leftbarsearch" onChange={(e:any)=>{searchContact(e);}}/>
          {/* feature is not implemented */}
          {/* <div className={styles.createContact}>
            <span><img src={createContact} alt="" /></span> Create Contacts
          </div> */}
        </div>
        {/* <div className={styles.request}>
          <span className={styles.requestText}>Requested Contacts</span>
        </div> */}
        <div className={styles.rightbartop}>
      {  contactList.allContacs.length>0 && <div className={styles.lefts}>
           <Dropdown overlay={menus} trigger={['click']} placement="bottomLeft" className="popss2">
                <p onClick={()=> setdefaultContacts({...defaultContacts,isFilter:true})} className={defaultContacts.isFilter? `${styles.filterKeyActive}`:""}>{defaultContacts.filterKey.length > 0 ?
                  defaultContacts.filterKey :"All Contacts"}<span className={ `icon_down-arrow menudroprotate contactArrow`} ></span></p>
                
              </Dropdown>
            </div>}
          </div>
        <div className={`${styles.scrolllayerleft} ${"scrollerhover"}`}>
          {/* <div className={styles.rightbartop}>
            <div className={styles.lefts}>
              <h3>Contacts</h3>
            </div>
            <div className={styles.rights}>
           <Dropdown overlay={menus} trigger={['click']} placement="bottomRight" className="popss2">
                <p onClick={()=> setdefaultContacts({...defaultContacts,isFilter:true})} className={defaultContacts.isFilter? `${styles.filterKeyActive}`:""}>{defaultContacts.filterKey.length > 0 ?
                  defaultContacts.filterKey :"All"}<span className={ `icon_down-arrow menudroprotate`} ></span></p>
                
              </Dropdown>
            </div>
          </div> */}
          <div className={styles.middlelayermiddle}>
            <ContactLists  defaultContacts={defaultContacts}></ContactLists>
          </div>

        </div>
      </div>

      <Modal visible={isModalVisible} className={`${styles.newmessage} ${"modaloverwrite"} ${"taskcreation"}`}>
        <span className={`icon_close ${styles.cursorTop}`} />
        <h2>New Task <span className="icon_ticknote"></span></h2>
        {/* <CreateTaskCenter></CreateTaskCenter> */}
        <div className={`${styles.footersection} ${"footersection"}`}>
          <URButton className={styles.cancelbtn} name="Cancel"></URButton>
          <URButton className={styles.savebtn} onClick={handleCancel} name="Save"></URButton>
        </div>
      </Modal>
    </>
  );
});

export default LeftsideBars;